export default __webpack_public_path__ + "static/media/hero-image.142a0ed1.jpg";